export enum MimeTypes {
  epub = "application/epub+zip",
  doc = "application/msword",
  pdf = "application/pdf",
  gDoc = "application/vnd.google-apps.document",
  gFolder = "application/vnd.google-apps.folder",
  docx = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  txt = "text/plain",
}
